/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type AdVehicleStreamEmergencyStopStatusSubscriptionVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
  }>

export type AdVehicleStreamEmergencyStopStatusSubscription = {
  __typename?: 'Subscription'
  fccEmergencyStopStatus: {
    __typename?: 'FccEmergencyStopStatus'
    vehicleId: string
    status: Types.FccRequestStatus
    errors: Array<Types.FccEmergencyStopError>
    failedReason: string | null
  }
}

export const AdVehicleStreamEmergencyStopStatusDocument = gql`
    subscription AdVehicleStreamEmergencyStopStatus($vehicleId: ID!) {
  fccEmergencyStopStatus(vehicleId: $vehicleId) {
    vehicleId
    status
    errors
    failedReason
  }
}
    `

/**
 * __useAdVehicleStreamEmergencyStopStatusSubscription__
 *
 * To run a query within a React component, call `useAdVehicleStreamEmergencyStopStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamEmergencyStopStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdVehicleStreamEmergencyStopStatusSubscription({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAdVehicleStreamEmergencyStopStatusSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AdVehicleStreamEmergencyStopStatusSubscription,
    AdVehicleStreamEmergencyStopStatusSubscriptionVariables
  > &
    (
      | {
          variables: AdVehicleStreamEmergencyStopStatusSubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    AdVehicleStreamEmergencyStopStatusSubscription,
    AdVehicleStreamEmergencyStopStatusSubscriptionVariables
  >(AdVehicleStreamEmergencyStopStatusDocument, options)
}
export type AdVehicleStreamEmergencyStopStatusSubscriptionHookResult =
  ReturnType<typeof useAdVehicleStreamEmergencyStopStatusSubscription>
export type AdVehicleStreamEmergencyStopStatusSubscriptionResult =
  Apollo.SubscriptionResult<AdVehicleStreamEmergencyStopStatusSubscription>
